import { useLocation, useNavigate } from 'react-router-dom';

const tabs = [
  { path: '/', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', label: '首页' },
  { path: '/explore', icon: 'ri-map-pin-line', activeIcon: 'ri-map-pin-fill', label: '找地方' },
  { path: '/create-route', icon: 'ri-route-line', activeIcon: 'ri-route-fill', label: '生成路线' },
  { path: '/my-trips', icon: 'ri-suitcase-line', activeIcon: 'ri-suitcase-fill', label: '我的行程' },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path: string) => {
    if (path === '/') return currentPath === '/';
    return currentPath.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-divider safe-area-bottom">
      <div className="flex items-center justify-around h-14 max-w-lg mx-auto">
        {tabs.map((tab) => {
          const active = isActive(tab.path);
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className="flex flex-col items-center justify-center flex-1 h-full cursor-pointer"
            >
              <i
                className={`${active ? tab.activeIcon : tab.icon} text-xl leading-none`}
                style={{ color: active ? '#2E7D32' : '#7B877D' }}
              />
              <span
                className="text-[10px] mt-0.5 font-medium"
                style={{ color: active ? '#2E7D32' : '#7B877D' }}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}